import { UserService } from '@/shared/services';
import { CommonModule } from '@angular/common';
import {
    AfterViewInit,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnDestroy,
    Output,
    ViewChild,
    inject,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { environment } from '@environments/environment';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { Subscription } from 'rxjs';
import { NavGroup } from '../../brain-tab-nav-group.interface';

@Component({
    selector: 'app-brain-tab-favorites',
    standalone: true,
    imports: [CommonModule, NgxSkeletonLoaderModule, RouterModule],
    templateUrl: './brain-tab-favorites.component.html',
    styleUrls: ['./brain-tab-favorites.component.css'],
})
export class BrainTabFavoritesComponent implements AfterViewInit, OnDestroy {
    userService = inject(UserService);

    @Input() group: NavGroup;
    @ViewChild('favList') favList: ElementRef;

    @Output() login = new EventEmitter<boolean>();
    gknUrl = environment.gkn.url;

    private sub: Subscription;

    constructor() {}

    ngAfterViewInit() {
        this.sub = this.group.favorites$.subscribe(() => {
            this.favList?.nativeElement?.classList.add('expanded');
        });
    }

    formatUrl(fav: any): string {
        const url = environment.gkn.url + '/' + fav.routerLink + '?' + 'product=' + fav.productId + '#' + fav?.id;
        console.log(`favorite url::${fav.id}: `, url);
        return `${this.gknUrl}/${fav.routerLink}?product=${fav.productId}#${fav.id}`;
    }

    handleLogin(e: Event): void {
        e?.stopPropagation();
        this.login.emit();
    }

    ngOnDestroy(): void {
        this.sub?.unsubscribe();
    }
}
